import React from "react";

export const CreateNFeContext = React.createContext({ step: 0 });



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Context/index.js